export interface percentage {
    id: number;
    value: number;
}
export const slim_2: Array<percentage> = [
    {
        id:0,
        value: 0,
    },
    {
        id:1,
        value: 10,
    },
    {
        id:2,
        value: 20,
    },
    {
        id:3,
        value: 30,
    },
    {
        id:4,
        value: 40,
    },
    {
        id:5,
        value: 50,
    },
    {
        id:6,
        value:60,
    },
    {
        id:7,
        value: 70,
    },{
        id:8,
        value: 80,
    },{
        id:9,
        value: 90,
    },{
        id:10,
        value: 100,
    },
];
